"use strict";

$(document).ready(function () {
  $(".system-profile .save-location, .system-location-banner .save-location").each(function () {
    var id = $(this).attr('data-location-id');
    var value = localStorage.getItem('favorite-locations');
    if (value !== null && value.includes(id)) {
      $(this).addClass('saved');
    }
  });
  $(".system-profile .save-location, .system-location-banner .save-location").click(function () {
    var id = $(this).attr('data-location-id');
    if (id === undefined) return;
    var value = localStorage.getItem('favorite-locations');
    var ids = null;
    if (value == null || value == '') {
      ids = id.split(',');
      $(this).addClass('saved');
    } else {
      ids = value.split(',');
      if (ids.includes(id)) {
        ids = ids.filter(function (e) {
          return e !== id;
        });
        $(this).removeClass('saved');
      } else {
        ids.push(id);
        $(this).addClass('saved');
      }
    }
    localStorage.setItem('favorite-locations', ids.join(','));
  });
});